export const specificationsIconMap = {
  mileage: '-191px -74px',
  battery: '-362px -133px',
  engineDescription: '-2px -74px',
  transmissionManual: '-191px -7px',
  transmissionAuto: '-65px -133px',
  driveTypeFront: '-129px -133px',
  driveTypeRear: '-65px -70px',
  driveTypeAll: '-66px -6px',
  mpgHybrid: '-6px -6px',
  mpgFuel: '-126px -6px',
  truckBedLength: '-128px -70px',
  range: '-1px -133px',
  evRange: '-1px -133px',
  windowSticker: '-1px -194px',
  warranty: '-65px -192px',
  trendingNewCars: '-131px -192px',
  hybridSuvs: '-252px -5px',
  reliable: '-192px -191px',
  familyFriendly: '-252px -130px',
  affordableElectric: '-310px -5px',
  adventureOffRoad: '-308px -70px',
  headsUpDisplay: '-252px -70px',
  affordableNewCars: '-252px -192px',
  inspectionChecklist: '-309px -133.5px',
  vin: '-364px -192px',
  fraudProtection: '-308px -192px',
  diamond: '-365px -70px',
  detailed: '-364px -5px'
};
export const tabsIconMap = {
  allResults: '-3px -11px',
  goodDeals: ' -63px -11px',
  buyOnline: ' -132px -11px',
  ownerSale: '-190px -10px',
  certifiedUsed: '-250px -11px'
};
export default {
  specificationsIconMap,
  tabsIconMap
};